"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecutableItem = exports.ExecutableType = void 0;
var ExecutableType;
(function (ExecutableType) {
    ExecutableType["ExecutionGroup"] = "executionGroup";
    ExecutableType["BasicFunction"] = "expectedBasicFunction";
    ExecutableType["LessonNode"] = "lessonNode";
})(ExecutableType = exports.ExecutableType || (exports.ExecutableType = {}));
class ExecutableItem {
    constructor() {
        this.userModeExecStatus = {
            isComplete: false,
        };
    }
    markComplete() {
        this.userModeExecStatus.isComplete = true;
    }
    skipNode() {
        this.markComplete();
        this.extras.logger.info(`Skipping ${this.executableType}`);
        return {
            skipped: true,
            result: false,
        };
    }
    passiveModeSkip() {
        this.markComplete();
        this.extras.logger.info(`Passive Skip of node ${this.executableType}`);
        return false;
    }
}
exports.ExecutableItem = ExecutableItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhlY3V0YWJsZUl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL0V4ZWN1dGFibGVJdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUlBLElBQVksY0FJWDtBQUpELFdBQVksY0FBYztJQUN4QixtREFBaUMsQ0FBQTtJQUNqQyx5REFBdUMsQ0FBQTtJQUN2QywyQ0FBeUIsQ0FBQTtBQUMzQixDQUFDLEVBSlcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFJekI7QUFnQkQsTUFBc0IsY0FBYztJQUFwQztRQU1FLHVCQUFrQixHQUF1QjtZQUN2QyxVQUFVLEVBQUUsS0FBSztTQUNsQixDQUFDO0lBNkJKLENBQUM7SUEzQkMsWUFBWTtRQUNWLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxVQUFVLEdBQUcsSUFBSSxDQUFDO0lBQzVDLENBQUM7SUFDRCxRQUFRO1FBQ04sSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO1FBQ3BCLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxZQUFZLElBQUksQ0FBQyxjQUFjLEVBQUUsQ0FBQyxDQUFDO1FBQzNELE9BQU87WUFDTCxPQUFPLEVBQUUsSUFBSTtZQUNiLE1BQU0sRUFBRSxLQUFLO1NBQ2QsQ0FBQztJQUNKLENBQUM7SUFFRCxlQUFlO1FBQ2IsSUFBSSxDQUFDLFlBQVksRUFBRSxDQUFDO1FBQ3BCLElBQUksQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyx3QkFBd0IsSUFBSSxDQUFDLGNBQWMsRUFBRSxDQUFDLENBQUM7UUFDdkUsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0NBV0Y7QUFyQ0Qsd0NBcUNDIn0=